import { useEffect, useRef } from "react";
import { STYX_THEME } from "../styles/theme";
import { getCanvasThemeColors, THEME_CHANGE_EVENT } from "../styles/themePalette";

function randomGlyph() {
  const chars = STYX_THEME.matrixGlyphs;
  return chars[Math.floor(Math.random() * chars.length)] ?? "0";
}

export function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const themeRef = useRef(getCanvasThemeColors());

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let raf = 0;
    let width = 0;
    let height = 0;
    let columns: number[] = [];

    const resize = () => {
      const ratio = window.devicePixelRatio || 1;
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.floor(width * ratio);
      canvas.height = Math.floor(height * ratio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      const count = Math.max(12, Math.floor(width / 18));
      columns = Array.from({ length: count }, () => Math.random() * height);
    };

    const syncTheme = () => {
      themeRef.current = getCanvasThemeColors();
    };

    const draw = () => {
      ctx.fillStyle = themeRef.current.backgroundFade;
      ctx.fillRect(0, 0, width, height);
      ctx.font = '18px monospace';

      columns = columns.map((y, i) => {
        const x = i * 18;
        ctx.fillStyle = `rgba(${themeRef.current.accentRgb}, ${0.08 + Math.random() * 0.12})`;
        ctx.fillText(randomGlyph(), x, y);
        if (y > height + Math.random() * 120) return 0;
        return y + 18;
      });

      raf = window.requestAnimationFrame(draw);
    };

    syncTheme();
    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener(THEME_CHANGE_EVENT, syncTheme);
    return () => {
      window.removeEventListener("resize", resize);
      window.removeEventListener(THEME_CHANGE_EVENT, syncTheme);
      window.cancelAnimationFrame(raf);
    };
  }, []);

  return <canvas ref={canvasRef} className="matrix-rain" aria-hidden="true" />;
}
